export default __webpack_public_path__ + "a0aa0b93534b9f918c2168a4240e7bde.woff";